export var initCaptcha = function () {
    return new Promise(function (resolve) {
        var captchaContainer = document.querySelector('#hCaptcha');
        if (!captchaContainer)
            return resolve('');
        var script = document.querySelector('#hcaptchaScript');
        var siteKey = script === null || script === void 0 ? void 0 : script.getAttribute('data-sitekey');
        function renderCaptcha() {
            var hcaptchaWindow = window;
            if (!hcaptchaWindow) {
                return;
            }
            hcaptchaWindow.hcaptcha.render('hCaptcha', {
                sitekey: siteKey,
                callback: function (response) { return resolve(response); }
            });
        }
        if (window.hcaptcha) {
            renderCaptcha();
        }
        else {
            script === null || script === void 0 ? void 0 : script.addEventListener('load', renderCaptcha);
        }
    });
};
